import IRSVerificationForm from "./IRSVerificationForm";

export default IRSVerificationForm;
